import type {
  ActionType,
  ActionTypePrefix,
} from '@polyai/stream/utils/rich-text-input';

export const FUNCTION_PREFIX = 'fn:';
export const FLOW_TRANSITION_PREFIX = 'ft:';
export const HANDOFF_PREFIX = 'ho:';
export const TWILIO_SMS_PREFIX = 'twilio_sms:';
export const VARIANT_ATTRIBUTE_PREFIX = 'attr:';
export const ENTITY_PREFIX = 'entity:';
export const VARIABLE_PREFIX = 'vrbl:';
export const INTEGRATION_PREFIX = 'integration:';
export const TRANSLATION_PREFIX = 'tn:';

export const ACTION_TAG_REGEXES = [
  FUNCTION_PREFIX,
  FLOW_TRANSITION_PREFIX,
  HANDOFF_PREFIX,
  TWILIO_SMS_PREFIX,
  VARIANT_ATTRIBUTE_PREFIX,
  ENTITY_PREFIX,
  VARIABLE_PREFIX,
  INTEGRATION_PREFIX,
  TRANSLATION_PREFIX,
].map(prefix => new RegExp(`\\{\\{(${prefix})([a-zA-Z0-9-:]+)\\}\\}`));

export const ActionTypeToPrefixMap = {
  function: 'fn:',
  handoff: 'ho:',
  twilio_sms: 'twilio_sms:',
  flow_transition: 'ft:',
  variant_attribute: 'attr:',
  entity: 'entity:',
  variable: 'vrbl:',
  integration: 'integration:',
  translation: 'tn:',
};

export const prefixMap = {
  [FUNCTION_PREFIX]: 'function',
  [HANDOFF_PREFIX]: 'handoff',
  [TWILIO_SMS_PREFIX]: 'twilio_sms',
  [FLOW_TRANSITION_PREFIX]: 'flow_transition',
  [VARIANT_ATTRIBUTE_PREFIX]: 'variant_attribute',
  [ENTITY_PREFIX]: 'entities',
  [VARIABLE_PREFIX]: 'variable',
  [INTEGRATION_PREFIX]: 'integration',
  [TRANSLATION_PREFIX]: 'translation',
} satisfies { [key in ActionTypePrefix]: ActionType };
